<template>
  <div class="container-fluid container-wrap col-sm-12 col-xs-12">
    <div class="row justify-content-center">
      <div class="col-sm-12 col-xs-12">
        <div class="pb-0 col-sm-12 d-flex mainDiv">
          <div class="col-sm-12 col-xs-12">
            <!-- 타이틀 영역 -->
            <div class="col-sm-12 col-xs-12 titleDiv CertListTitle justify-content-between title-area">
              <div>
                <h3>제품 관리</h3>
                <h5>시스템에서 제공하는 제품의 가격 및 정보를 관리합니다.</h5>
              </div>
            </div>

            <!-- 로딩 상태 -->
            <div v-if="loading" class="loading-container">
              <a-spin size="large" />
            </div>

            <!-- 제품 카드 그리드 -->
            <div v-else class="product-grid">
              <ProductCard
                v-for="product in products"
                :key="product.id"
                :product="product"
                @edit="openEditModal"
              />
            </div>

            <!-- 데이터 없음 -->
            <div v-if="!loading && products.length === 0" class="empty-state">
              <i class="fa-solid fa-box-open" />
              <p>등록된 제품이 없습니다.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 수정 모달 -->
    <ProductEditModal
      :visible="editModal.visible"
      :product="editModal.product"
      @close="closeEditModal"
      @updated="handleUpdated"
    />
  </div>
</template>

<script>
import { message } from 'ant-design-vue';
import ProductCard from './components/ProductCard.vue';
import ProductEditModal from './components/ProductEditModal.vue';
import { systemProductApi } from './api';

export default {
  name: 'SystemProductList',
  components: {
    ProductCard,
    ProductEditModal,
  },
  data() {
    return {
      loading: false,
      products: [],
      editModal: {
        visible: false,
        product: null,
      },
    };
  },
  mounted() {
    this.fetchProducts();
  },
  methods: {
    async fetchProducts() {
      this.loading = true;
      try {
        this.products = await systemProductApi.getAll();
      } catch (error) {
        console.error('제품 목록 조회 실패:', error);
        message.error('제품 목록을 불러오는데 실패했습니다.');
      } finally {
        this.loading = false;
      }
    },
    openEditModal(product) {
      this.editModal.product = product;
      this.editModal.visible = true;
    },
    closeEditModal() {
      this.editModal.visible = false;
      this.editModal.product = null;
    },
    handleUpdated() {
      this.fetchProducts();
    },
  },
};
</script>

<style lang="scss" scoped>
.row {
  padding: 28px 28px 72px 28px !important;
}

.title-area {
  margin-bottom: 24px;

  h3 {
    margin: 0;
    font-size: 24px;
    font-weight: 700;
    color: #17191c;
  }

  h5 {
    margin: 8px 0 0;
    font-size: 14px;
    font-weight: 400;
    color: #666;
  }
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;

  @media screen and (max-width: 1400px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media screen and (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (max-width: 640px) {
    grid-template-columns: 1fr;
  }
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  color: #999;

  i {
    font-size: 48px;
    margin-bottom: 16px;
  }

  p {
    font-size: 16px;
    margin: 0;
  }
}
</style>
